/**
 * Grain LP
 *
 * Interactions follow molnGrain_LP仕様書: gallery reveal, process preview,
 * colour-gated gallery, and accordion matching product pages.
 */
(function () {
  'use strict';

  if (window.__GRAIN_LP__) return;
  window.__GRAIN_LP__ = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Parallax follows data-parallax on each collage photo. */
  var enableParallax = true;

  /* -------------------------------------------------------------- hero -- */

  (function () {
    var lockup = document.querySelector('.GrainHero__Lockup');
    if (!lockup) return;

    function reveal() {
      if (reduceMotion) {
        lockup.classList.add('is-in');
        return;
      }
      window.setTimeout(function () {
        lockup.classList.add('is-in');
      }, 1300);
    }

    var heroImg = document.querySelector('.GrainHero__Media img');
    if (!heroImg || heroImg.complete) reveal();
    else {
      heroImg.addEventListener('load', reveal, { once: true });
      heroImg.addEventListener('error', reveal, { once: true });
    }
  })();

  /* ----------------------------------------------------------- gallery -- */

  var storyPhotos = Array.prototype.slice.call(document.querySelectorAll('.GrainStory__Photo'));

  storyPhotos.forEach(function (photo) {
    if (reduceMotion) {
      photo.classList.add('is-in');
      return;
    }
    if (!('IntersectionObserver' in window)) {
      photo.classList.add('is-in');
      return;
    }
    var watcher = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          watcher.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -12% 0px' }
    );
    requestAnimationFrame(function () {
      watcher.observe(photo);
    });
  });

  if (!reduceMotion && enableParallax && storyPhotos.length) {
    var parallaxFrame = 0;

    function shiftPhoto(photo) {
      var rate = parseFloat(photo.getAttribute('data-parallax') || '0.12');
      if (!rate) return;
      var parent = photo.offsetParent;
      if (!parent) return;
      var parentRect = parent.getBoundingClientRect();
      var height = photo.offsetHeight;
      var top = parentRect.top + photo.offsetTop;
      var slack = window.innerHeight * 0.4;
      if (top + height < -slack || top > window.innerHeight + slack) return;
      var delta = (window.innerHeight * 0.5 - (top + height * 0.5)) * rate;
      photo.style.transform = 'translate3d(0, ' + delta.toFixed(1) + 'px, 0)';
    }

    function tickParallax() {
      parallaxFrame = 0;
      storyPhotos.forEach(shiftPhoto);
    }

    function requestParallax() {
      if (parallaxFrame) return;
      parallaxFrame = window.requestAnimationFrame(tickParallax);
    }

    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax);
    requestParallax();
  }

  /* ----------------------------------------------------------- videos -- */

  function playWhenVisible(video, options) {
    options = options || {};
    var root = options.root || video;

    function start() {
      if (options.canPlay && !options.canPlay()) return;
      if (video.paused) {
        try { video.currentTime = 0; } catch (error) {}
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
    }

    function stop() {
      if (options.canPause && !options.canPause()) return;
      if (!video.paused) video.pause();
    }

    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }

    var watcher = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    watcher.observe(root);
  }

  document.querySelectorAll('[data-grain-feature-video]').forEach(function (video) {
    video.muted = true;
    video.loop = true;
    playWhenVisible(video, { root: video.closest('.GrainFeatures__Row') || video });
  });

  document.querySelectorAll('[data-grain-craft]').forEach(function (media) {
    var video = media.querySelector('[data-grain-craft-video]');
    var play = media.querySelector('[data-grain-craft-play]');
    if (!video || !play) return;

    var previewing = true;

    function inPreview() {
      return previewing;
    }

    function armPreview() {
      previewing = true;
      media.classList.remove('GrainCraft__Media--playing');
      video.muted = true;
      video.loop = true;
      video.removeAttribute('controls');
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    function isFull() {
      return document.fullscreenElement === video
        || document.webkitFullscreenElement === video
        || video.webkitDisplayingFullscreen;
    }

    function exitFull() {
      if (document.fullscreenElement) document.exitFullscreen();
      else if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      armPreview();
    }

    video.muted = true;
    video.loop = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.addEventListener('playing', function () {
      if (previewing) media.classList.add('GrainCraft__Media--live');
    });

    playWhenVisible(video, {
      root: media,
      canPlay: inPreview,
      canPause: inPreview
    });

    function expand() {
      if (!previewing) return;
      previewing = false;
      media.classList.add('GrainCraft__Media--playing');
      video.pause();
      video.muted = false;
      video.loop = false;
      video.currentTime = 0;
      video.setAttribute('controls', '');
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(armPreview);
      if (video.requestFullscreen) video.requestFullscreen();
      else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    }

    media.addEventListener('click', function () {
      expand();
    });
    play.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      expand();
    });

    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (name) {
      document.addEventListener(name, function () {
        if (previewing) return;
        if (!isFull()) armPreview();
      });
    });
    video.addEventListener('webkitendfullscreen', armPreview);
    video.addEventListener('ended', function () {
      if (!isFull()) armPreview();
      else exitFull();
    });
  });

  /* -------------------------------------------------------------- buy -- */

  var section = document.querySelector('[data-section-type="grain-buy"]');
  if (section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-grain-slide]'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-grain-thumb]'));
    var chips = Array.prototype.slice.call(section.querySelectorAll('[data-grain-variant]'));
    var variantInput = section.querySelector('[data-grain-variant-input]');
    var priceTarget = section.querySelector('[data-grain-price-target]');
    var submit = section.querySelector('[data-grain-submit]');
    var main = section.querySelector('.GrainBuy__Main');
    var thumbsWrap = section.querySelector('[data-grain-thumbs]');
    var scroller = section.querySelector('[data-grain-scroll]');
    var scrollThumb = section.querySelector('[data-grain-scroll-thumb]');
    var dragging = false;

    function isCompact() {
      return window.matchMedia('(max-width: 640px)').matches;
    }

    function updateScroller() {
      if (!thumbsWrap || !scroller || !scrollThumb) return;
      if (!isCompact()) {
        scroller.hidden = true;
        return;
      }
      var view = thumbsWrap.clientWidth;
      var total = thumbsWrap.scrollWidth;
      var max = total - view;
      if (max <= 1) {
        scroller.hidden = true;
        return;
      }
      scroller.hidden = false;
      scrollThumb.style.width = ((view / total) * 100) + '%';
      scrollThumb.style.left = ((thumbsWrap.scrollLeft / total) * 100) + '%';
      scroller.setAttribute('aria-valuenow', String(Math.round((thumbsWrap.scrollLeft / max) * 100)));
    }

    function scrollToClientX(clientX) {
      if (!thumbsWrap || !scroller || !scrollThumb) return;
      var track = scroller.querySelector('.GrainBuy__ScrollTrack') || scroller;
      var rect = track.getBoundingClientRect();
      var thumbW = scrollThumb.offsetWidth;
      var maxX = Math.max(1, rect.width - thumbW);
      var x = clientX - rect.left - thumbW / 2;
      if (x < 0) x = 0;
      if (x > maxX) x = maxX;
      thumbsWrap.scrollLeft = (x / maxX) * (thumbsWrap.scrollWidth - thumbsWrap.clientWidth);
    }

    function revealThumb(el) {
      if (!isCompact() || !thumbsWrap || !el) return;
      var left = el.offsetLeft;
      var right = left + el.offsetWidth;
      if (left < thumbsWrap.scrollLeft) thumbsWrap.scrollLeft = left;
      else if (right > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) {
        thumbsWrap.scrollLeft = right - thumbsWrap.clientWidth;
      }
    }

    var playlist = [];
    var index = 0;
    var color = (chips[0] && chips[0].getAttribute('data-grain-color')) || 'white';
    var firstImageKey = (section.getAttribute('data-grain-first-image') || 'handle').toLowerCase();

    chips.forEach(function (chip) {
      if (chip.getAttribute('aria-checked') === 'true') {
        color = chip.getAttribute('data-grain-color') || color;
      }
    });

    function byGroup(group) {
      return slides
        .map(function (slide, i) {
          return { slide: slide, thumb: thumbs[i], group: slide.getAttribute('data-grain-group') || 'shared', i: i };
        })
        .filter(function (item) {
          return item.group === group;
        });
    }

    function prioritizeFirst(items) {
      if (!firstImageKey) return items;
      var heroes = [];
      var rest = [];
      items.forEach(function (item) {
        var file = (
          item.slide.getAttribute('data-grain-file') ||
          item.slide.getAttribute('src') ||
          ''
        ).toLowerCase();
        if (file.indexOf(firstImageKey) !== -1) heroes.push(item);
        else rest.push(item);
      });
      return heroes.concat(rest);
    }

    function buildPlaylist(nextColor) {
      color = nextColor || color;
      playlist = prioritizeFirst(byGroup(color)).concat(byGroup('shared'));
      if (!playlist.length) {
        playlist = slides.map(function (slide, i) {
          return { slide: slide, thumb: thumbs[i], group: 'shared', i: i };
        });
      }
    }

    function show(next) {
      if (!playlist.length) return;
      index = (next + playlist.length) % playlist.length;
      var current = playlist[index];

      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', 'true');
      });
      thumbs.forEach(function (thumb) {
        thumb.hidden = true;
        thumb.setAttribute('aria-current', 'false');
      });

      playlist.forEach(function (item, i) {
        if (item.thumb) {
          item.thumb.hidden = false;
          item.thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        }
      });
      current.slide.classList.add('is-active');
      current.slide.setAttribute('aria-hidden', 'false');

      if (main && !main.classList.contains('is-ready')) {
        window.requestAnimationFrame(function () {
          main.classList.add('is-ready');
        });
      }

      revealThumb(current.thumb);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(updateScroller);
      });
    }

    buildPlaylist(color);
    show(0);

    if (thumbsWrap) {
      thumbsWrap.addEventListener('scroll', updateScroller, { passive: true });
      window.addEventListener('resize', updateScroller);
    }
    if (scroller && scrollThumb) {
      scroller.addEventListener('pointerdown', function (event) {
        dragging = true;
        if (scroller.setPointerCapture) scroller.setPointerCapture(event.pointerId);
        scrollToClientX(event.clientX);
        event.preventDefault();
      });
      scroller.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        scrollToClientX(event.clientX);
      });
      function stopDrag() {
        dragging = false;
      }
      scroller.addEventListener('pointerup', stopDrag);
      scroller.addEventListener('pointercancel', stopDrag);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var pos = -1;
        playlist.forEach(function (item, i) {
          if (item.thumb === thumb) pos = i;
        });
        if (pos > -1) show(pos);
      });
    });

    if (main) {
      var startX = null;
      main.addEventListener('touchstart', function (event) {
        if (event.changedTouches && event.changedTouches[0]) {
          startX = event.changedTouches[0].clientX;
        }
      }, { passive: true });
      main.addEventListener('touchend', function (event) {
        if (startX === null || !event.changedTouches || !event.changedTouches[0]) return;
        var dx = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        show(index + (dx < 0 ? 1 : -1));
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (other) {
          other.setAttribute('aria-checked', other === chip ? 'true' : 'false');
        });

        if (variantInput) variantInput.value = chip.getAttribute('data-grain-variant');
        if (priceTarget) priceTarget.innerHTML = chip.getAttribute('data-grain-price');
        if (submit) submit.disabled = chip.getAttribute('data-grain-available') !== 'true';

        buildPlaylist(chip.getAttribute('data-grain-color') || color);
        show(0);
      });
    });

    var form = section.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault();
        if (submit) submit.disabled = true;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        fetch(form.getAttribute('action'), {
          body: new FormData(form),
          credentials: 'same-origin',
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if (submit) submit.disabled = false;
            if (!response.ok) {
              form.submit();
              return;
            }
            document.dispatchEvent(
              new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } })
            );
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if (submit) submit.disabled = false;
            form.submit();
          });
      });
    }

    var wrappers = Array.prototype.slice.call(
      section.querySelectorAll('[data-grain-accordion] .Product__Compensation__Wrapper')
    );

    wrappers.forEach(function (wrapper, i) {
      var title = wrapper.querySelector('.Product__Compensation__Title');
      var content = wrapper.querySelector('.Product__Compensation__Content');

      function open() {
        title.setAttribute('aria-expanded', 'true');
        content.setAttribute('aria-expanded', 'true');
        content.style.opacity = '1';
        content.style.height = 'auto';
      }

      function close() {
        title.setAttribute('aria-expanded', 'false');
        content.setAttribute('aria-expanded', 'false');
        content.style.opacity = '0';
        content.style.height = '0';
      }

      if (i === 0) open();
      else close();

      wrapper.addEventListener('click', function () {
        if (title.getAttribute('aria-expanded') === 'true') close();
        else open();
      });
    });
  }
})();
